import React from "react";
import { Link } from "react-router-dom";

function WorkProcessSection() {
  return (
    <div>
      <section className="work-process-section bg-dark">
        <div className="divider"></div>

        <div className="container process-container">
          <div className="row g-5">
            <div className="col-12 col-md-5 col-xl-6">
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Process
                </div>
                <h2 className="mb-5 text-white">
                  Our Streamlined Legal Process
                </h2>
                <Link className="btn btn-primary" to="/bookconsultation">
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Book Consultation <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>

            <div className="col-md-7 col-xl-6">
              <div
                className="work-process wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="400ms"
              >
                {/* Work Process Card */}
                <div className="process-card">
                  <div className="number">1</div>
                  <div className="process-text">
                    <div className="process-title">Book Consultation</div>
                    <p className="mb-0">
                      Begin your journey with us by scheduling a consultation at your convenience. We make it easy to connect with the right legal expert for your needs — whether in person, by phone, or virtually.
                    </p>
                  </div>
                </div>

                {/* Work Process Card */}
                <div className="process-card">
                  <div className="number">2</div>
                  <div className="process-text">
                    <div className="process-title">Discovery Call</div>
                    <p className="mb-0">
                      In this initial conversation, our legal team listens carefully to understand your situation, objectives, and concerns. This call helps us align on expectations and identify the most effective path forward.
                    </p>
                  </div>
                </div>

                {/* Work Process Card */}
                <div className="process-card">
                  <div className="number">3</div>
                  <div className="process-text">
                    <div className="process-title">Case Analysis</div>
                    <p className="mb-0">
                      Our attorneys conduct a thorough review of the facts, applicable laws, and relevant precedents. We deliver a clear, honest assessment of your case and the legal strategies available to you.
                    </p>
                  </div>
                </div>

                {/* Work Process Card */}
                <div className="process-card">
                  <div className="number">4</div>
                  <div className="process-text">
                    <div className="process-title">Budgeting</div>
                    <p className="mb-0">
                      We provide transparent cost estimates and flexible fee arrangements tailored to your matter. Our goal is to ensure quality legal representation that is predictable and within reach.
                    </p>
                  </div>
                </div>

                {/* Work Process Card */}
                <div className="process-card">
                  <div className="number">5</div>
                  <div className="process-text">
                    <div className="process-title">Execution</div>
                    <p className="mb-0">
                      With a clear strategy and agreed scope, our team moves swiftly and precisely to execute on your behalf — negotiating, drafting, litigating, or advising until your matter is fully resolved.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
      </section>
    </div>
  );
}

export default WorkProcessSection;
